import {Component, OnInit} from '@angular/core';
import {NavigationComponent} from '../../commons/component/navigation-component/navigation-component';
import {ChartTemplate, CssTemplateDto, ThemeDto} from '../../model/Theme';
import {ThemeService} from '../../services/theme-service';
import {
    DxButtonModule, DxFormModule,
    DxPopupModule,
    DxTabPanelModule,
    DxTextBoxModule
} from 'devextreme-angular';
import {AddEditComponent} from '../add-edit-component/add-edit-component';
import notify from 'devextreme/ui/notify';
import {switchMap} from 'rxjs';
import {NgClass} from '@angular/common';
import {AddEditCssComponent} from "../add-edit-css-component/add-edit-css-component";
import {CssTemplateService} from "../../services/css-template-service";
import {DxiValidationRuleModule} from "devextreme-angular/ui/nested";
import {ChartPanelComponent} from "../chart-panel-component/chart-panel-component";


@Component({
  selector: 'app-home-component',
    imports: [
        NavigationComponent,
        AddEditComponent,
        AddEditCssComponent,
        ChartPanelComponent,
        DxTextBoxModule,
        DxButtonModule,
        DxPopupModule,
        DxTabPanelModule,
        NgClass,
        DxFormModule,
        DxiValidationRuleModule
    ],
  templateUrl: './home-component.html',
  styleUrl: './home-component.scss'
})
export class HomeComponent implements OnInit{

  themes: ThemeDto[] = [];
  filteredThemes: ThemeDto[] = [];
  selectedTheme: ThemeDto = {} as ThemeDto;
  removeTheme?: ThemeDto|null;
  showForm: boolean = false;
  searchQuery: string = '';

  cssTemplates: CssTemplateDto[] = [];
  filteredCssTemplates: CssTemplateDto[] = [];
  selectedCssTemplate: CssTemplateDto = {} as CssTemplateDto;
  removeCssTemplate?: CssTemplateDto|null;
  showCssForm: boolean = false;

  selectedChartTemplate: ChartTemplate = {} as ChartTemplate;
  showChartForm: boolean = false;

  constructor(private themeService: ThemeService,
              private cssTemplateService: CssTemplateService) {
  }

  ngOnInit() {
    this.listThemes();
    this.listCssTemplates();
  }

  listThemes() {
    this.themeService.getAllThemes().subscribe(res => {
      this.themes = res;
      this.filteredThemes = res;
    });
  }

  remove(id: string) {
    this.themeService.remove(id)
      .pipe(
        switchMap(res => {
          return this.themeService.getAllThemes();
        })
      )
      .subscribe((res) => {
        this.themes = res;
        this.filteredThemes = res;

        notify(`Theme ${this.removeTheme?.name} removed`, "success");
        this.removeTheme = null;
    });
  }

    onTabChanging(e: any) {
        const nextTabTitle = e.addedItems?.[0]?.title;
        this.showChartForm = nextTabTitle === 'Chart Templates';
    }

    removeTemplate(id: string) {
        this.cssTemplateService.remove(id)
            .pipe(
                switchMap(res => {
                    return this.cssTemplateService.getAllTemplates();
                })
            )
            .subscribe((res) => {
                this.cssTemplates = res;
                this.filteredCssTemplates = res;

                notify(`Template ${this.removeCssTemplate?.name} removed`, "success");
                this.removeCssTemplate = null;
            });
      }

  openCreatePopup() {
    this.showForm = !this.showForm;
    this.selectedTheme = {} as ThemeDto;
  }

  openEditDialog(id: string) {
    this.themeService.getById(id).subscribe(res => {
      this.selectedTheme = res;
      this.showForm = true;
    });
  }

  getThemePreview(id: string) {
      return this.themeService.getThemePreview(id);
  }

  onSearch() {
    if (!this.searchQuery.trim()) {
      this.filteredThemes = this.themes;
    } else {
      this.filteredThemes = this.themes.filter(theme =>
        theme.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  }

    onCssSearch(e: any) {
        const value = (e.value || '').toLowerCase();

        this.filteredCssTemplates = value
            ? this.cssTemplates.filter(t =>
                t.name?.toLowerCase().includes(value)
            )
            : this.cssTemplates;
    }

    openCreateCssPopup() {
        this.showCssForm = !this.showCssForm;
        this.selectedCssTemplate = {} as CssTemplateDto;
    }

    openEditCssDialog(id: string) {
        this.cssTemplateService.getById(id).subscribe(res => {
            this.selectedCssTemplate = res;
            this.showCssForm = true;
        });
    }

    listCssTemplates() {
        this.cssTemplateService.getAllTemplates().subscribe(res => {
            this.cssTemplates = res;
            this.filteredCssTemplates = res;
        });
    }
}
